module.exports = __webpack_public_path__ + "img/00002.15819af7.webp";